import styled from 'styled-components';

export const Container = styled.div`
  .hefesto-modal__container .hefesto-modal__header {
    h3 {
      margin: 0;
    }
    margin: 0;
  }

  .hefesto-modal__container div:nth-child(2) {
    overflow: visible;
  }
`;

export const ModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const ChipsContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const ChipsWrapper = styled.div`
  display: flex;
  justify-content: space-between;

  .hefesto-chip {
    flex: 1;

    & > div {
      justify-content: space-between;
    }

    .chip {
      width: 32px;
      height: 32px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 24px;
    }

    .mdc-chip-set {
      align-items: center;
    }

    .mdc-chip.mdc-chip--selected div.mdc-chip__text {
      margin-right: 0.5rem;
    }
  }
`;

export const ChipsDescription = styled.div`
  display: flex;
  flex: 1;
  justify-content: space-between;
  padding-right: 0.5rem;

  span {
    color: #333333;
    font-size: 14px;
    line-height: 22px;
    font-weight: 400;
  }
`;

export const ModalSubtitle = styled.span`
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  color: ${({ theme }) => theme.colors.grayDark4};
`;

export const SurveyContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;

  &:last-child {
    margin-bottom: 32px;
  }
`;

export const SurveyHeader = styled.div``;

export const SurveyTitle = styled.span`
  font-size: 16px;
  line-height: 24px;
  font-weight: 400;
  color: ${({ theme }) => theme.colors.grayDark4};
`;

export const SurveyRadioContainer = styled.div`
  margin-top: 4px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const RadioButtonWrapper = styled.div`
  padding-left: 0.3rem;
  max-height: 48px;
  display: flex;
  gap: 1rem;
  .hefesto-radiobutton {
    margin: 0;
    & > * .hefesto-radiobutton__slider--primary {
      border: 1px solid;
      border-color: ${({ theme }) => theme.colors.lightGray5};
    }
    :has(input:checked) {
      > * .hefesto-radiobutton__slider--primary {
        border-color: ${({ theme }) => theme.colors.blue6};
      }
    }
  }
`;

export const SurveySuccess = styled.div`
  margin-top: 1rem;
  display: flex;
  flex-direction: column;

  span {
    font-size: 16px;
    line-height: 24px;
    font-weight: 400;
    color: ${({ theme }) => theme.colors.grayDark4};
  }
`;
